"use client";

import { useCallback } from "react";

import { useSharedCarsQuery } from "./context/QueryContext";
import IconArrowDown from "@/components/Icons/IconArrowDown";
import { cn } from "@/lib/utils";

const Spinner = () => (
  <div className="h-4 w-4 animate-spin">
    <svg className="h-4 w-4 text-primary" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
      <path
        className="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      ></path>
    </svg>
  </div>
);

const ShowMoreButton = () => {
  const { fetchNextPage, hasNextPage, isFetchingNextPage } = useSharedCarsQuery();

  const handleShowMore = useCallback(async () => {
    if (!isFetchingNextPage && hasNextPage) {
      await fetchNextPage();
    }
  }, [fetchNextPage, hasNextPage, isFetchingNextPage]);

  if (!hasNextPage) return null;
  
  return (
    <button
      onClick={handleShowMore}
      disabled={isFetchingNextPage}
      className={cn(
        "mb-4 flex flex-grow items-center justify-center rounded-2xl border p-3 transition-all duration-300",
        isFetchingNextPage
          ? "cursor-not-allowed border-gray-200 bg-gray-50"
          : "border-white bg-white hover:cursor-pointer hover:border-primary",
        "focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2",
      )}
      aria-label={isFetchingNextPage ? "Loading more cars" : "Show more cars"}
    >
      <span className={cn("inter text-[14px] font-semibold", isFetchingNextPage && "text-gray-500")}>
        {isFetchingNextPage ? "Loading..." : "Show More"}
      </span>
      {isFetchingNextPage ? (
        <span className="ms-4">
          <Spinner />
        </span>
      ) : (
        <span className="inter ms-4 text-[14px] font-semibold">
          <IconArrowDown className="transition-transform duration-300" />
        </span>
      )}
    </button>
  );
};

export default ShowMoreButton;
